import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

const LockerHistoryColumnView = () => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <Column width={152} style={{marginLeft: '28px'}}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colLockerNumber')}</Text>
      </Column>
      <Column width={187}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colUsagePeriod')}</Text>
      </Column>
      <Column width={90}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colUsageDays')}</Text>
      </Column>
      <Column width={88}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colStatus')}</Text>
      </Column>
      <Column width={184}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colUsageAmount')}</Text>
      </Column>
      <Column width={70}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colLockerPayDate')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default LockerHistoryColumnView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 34px 0px 20px 0px;

  width: 1020px;

  gap: 12px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;
